__turbopack_context__.v({
  "button": "tools-module__JgPnVW__button",
  "calculator": "tools-module__JgPnVW__calculator",
  "contents": "tools-module__JgPnVW__contents",
  "divider": "tools-module__JgPnVW__divider",
  "earningsFields": "tools-module__JgPnVW__earningsFields",
  "earningsNote": "tools-module__JgPnVW__earningsNote",
  "earningsResults": "tools-module__JgPnVW__earningsResults",
  "editorial": "tools-module__JgPnVW__editorial",
  "error": "tools-module__JgPnVW__error",
  "eyebrow": "tools-module__JgPnVW__eyebrow",
  "faq": "tools-module__JgPnVW__faq",
  "hero": "tools-module__JgPnVW__hero",
  "heroMeta": "tools-module__JgPnVW__heroMeta",
  "page": "tools-module__JgPnVW__page",
  "pricing": "tools-module__JgPnVW__pricing",
  "pricingFields": "tools-module__JgPnVW__pricingFields",
  "related": "tools-module__JgPnVW__related",
  "result": "tools-module__JgPnVW__result",
  "resultCta": "tools-module__JgPnVW__resultCta",
  "resultHint": "tools-module__JgPnVW__resultHint",
  "resultTitle": "tools-module__JgPnVW__resultTitle",
  "resultValue": "tools-module__JgPnVW__resultValue",
  "review": "tools-module__JgPnVW__review",
  "section": "tools-module__JgPnVW__section",
  "tableScroll": "tools-module__JgPnVW__tableScroll",
  "textLink": "tools-module__JgPnVW__textLink",
});
